<template>
    <div class="Dashboard DivGlobalScroll">
        <Menu @menu-selected="handleMenuSelection" />
        <main style="flex:1; padding: 12px;">
            <Suspense>
                <router-view v-slot="{ Component }">
                    <component :is="Component" />
                </router-view>
            </Suspense>
        </main>
    </div>
</template>

<script>
import Menu from './MenuVertical.vue'
import Parse from "parse"

export default {
    name: 'DashboardComponent',
    components: {
        Menu
    },

    data() {
        return {
            super_admin: false
        }
    },

    methods: {
        handleMenuSelection(selectedMenu) {
            // Naviguer vers la route enfant correspondante
            // si l'item est conditionnel, le menu doit fournir la clé correcte
            let routePath = `/dashboard/${selectedMenu}`
            // Si selection = 'accueil' et qu'on veut la route par défaut, on navigue vers 'accueil'
            this.$router.push(routePath).catch(() => { })
        }
    },

    async created() {
        const user = Parse.User.current()
        this.super_admin = user?.attributes?.super_admin || false
    }
}
</script>
<style scoped>
.Dashboard {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #f5f7fa 0%, #b8c6db 100%);
}

.DivGlobalScroll::-webkit-scrollbar {
    width: 10px;
    /* Largeur de la barre de défilement */
}

.DivGlobalScroll::-webkit-scrollbar-track {
    background-color: #f7f9fc;
    /* Couleur de fond de la barre de défilement */
    border-radius: 5px;
    /* Bords arrondis pour la barre de défilement */
}

.DivGlobalScroll::-webkit-scrollbar-thumb {
    background-color: #00c4a7;
    /* Couleur de la barre de défilement elle-même */
    border-radius: 5px;
    /* Bords arrondis pour la barre de défilement */
}

.DivGlobalScroll::-webkit-scrollbar-thumb:hover {
    background-color: #009688;
    /* Couleur de la barre de défilement au survol */
}
</style>